<div class="sidebar">

    <div class="logo-holder logo">
        <div class="img"></div>
        <p><a routerLink="/"><span>WG</span>platform</a></p>
    </div>

    <nav>
        <ul>
            <li>
                <a routerLink="/">
                    <div class="item first-of-type">
                        <img src="/assets/images/ikona-dashboard@3x.png" />
                        <p>{{'HOME.MAINMENU_DASHBOARD' | translate}}</p>
                    </div>
                </a>
            </li>
            <li>
                <div class="item open-dropdown"
                    [ngClass]="{'open-dropdown': openedMenu=='forms', 'dropdown':openedMenu!='forms'}"
                    (click)="openMenu('forms')">
                    <img src="/assets/images/ikona-forms@3x.png" />
                    <p>{{'HOME.MAINMENU_FORMS' | translate}}</p>
                </div>
                <div class="submenu" *ngIf="openedMenu == 'forms'">
                    <div class="hover-overlay"></div>
                    <div class="sub-item" routerLink="/forms">
                        <p>{{'HOME.MAINMENU_FORMS_ALL' | translate}}</p>
                    </div>
                    <div class="sub-item" routerLink="/forms/masters">
                        <p>{{'HOME.MAINMENU_FORMS_MASTERS' | translate}}</p>
                    </div>
                    <div class="sub-item" routerLink="/forms/layouts">
                        <p>{{'HOME.MAINMENU_FORMS_LAYOUTS' | translate}}</p>
                    </div>
                </div>
            </li>
            <li>
                <div class="item open-dropdown"  [ngClass]="{'open-dropdown': openedMenu=='users', 'dropdown':openedMenu!='users'}" (click)="openMenu('users')">
                    <img src="/assets/images/ikona-user@3x.png" />
                    <p>{{'HOME.MAINMENU_USERSANDROLES' | translate}}</p>
                </div>
                <div class="submenu" *ngIf="openedMenu=='users'">
                    <div class="hover-overlay"></div>
                    <div class="sub-item" routerLink="/users">
                        <p>{{'HOME.MAINMENU_USERS' | translate}}</p>
                    </div>
                    <div class="sub-item" routerLink="/roles">
                        <p>{{'HOME.MAINMENU_ROLES' | translate}}</p>
                    </div>
                </div>
            </li>

            <li>
                <div class="item open-dropdown"  [ngClass]="{'open-dropdown': openedMenu=='navigation', 'dropdown':openedMenu!='navigation'}" (click)="openMenu('navigation')">
                    <img src="/assets/images/ikona-user@3x.png" />
                    <p>{{'HOME.MAINMENU_NAVIGATION' | translate}}</p>
                </div>
                <div class="submenu" *ngIf="openedMenu=='navigation'">
                    <div class="hover-overlay"></div>
                    <div class="sub-item" routerLink="/navigation/nodes">
                        <p>{{'HOME.MAINMENU_NAVIGATION_NODES' | translate}}</p>
                    </div>
                    <div class="sub-item" routerLink="/navigation/rules">
                        <p>{{'HOME.MAINMENU_NAVIGATION_RULES' | translate}}</p>
                    </div>
                </div>
            </li>

            <li>
                <a routerLink="/usersearchsetting">
                <div class="item">
                    <img src="/assets/images/ikona-providers@3x.png" />
                    <p>
                        {{'HOME.MAINMENU_SEARCHSETTINGS' | translate}}
                    </p>
                </div>
            </a>
            </li>

            <li>
                <a routerLink="/formaction">
                <div class="item">
                    <img src="/assets/images/ikona-providers@3x.png" />
                    <p>
                        {{'HOME.MAINMENU_FORMACTION' | translate}}
                    </p>
                </div>
            </a>
            </li>

            <li>
                <div class="item">
                    <img src="/assets/images/ikona-providers@3x.png" />
                    <p>
                        {{'HOME.MAINMENU_PROVIDERS' | translate}}
                    </p>
                </div>
            </li>

            <li>
                <div class="item">
                    <img src="/assets/images/ikona-workflows@3x.png" />
                    <p>{{'HOME.MAINMENU_WORKFLOWS' | translate}}</p>
                    <a href="/workflow" class="add"></a>
                </div>
            </li>

            <li>
                <div class="item">
                    <img src="/assets/images/ikona-reports@3x.png" />
                    <p>{{'HOME.MAINMENU_REPORTS' | translate}}</p>
                </div>
            </li>

            <li>
                <div class="item">
                    <img src="/assets/images/ikona-settings@3x.png" />
                    <p>{{'HOME.MAINMENU_SETTINGS' | translate}}</p>
                </div>
            </li>
        </ul>

    </nav>
</div>